import { StatisticsPresenter } from '@/presentation/presenters/dashboard/statisticsPresenter'
import { StatisticsViewModel } from '@/presentation/viewmodels/dashboard/statisticsViewModel'

export function useStatisticsPresenter(
  presenter: StatisticsPresenter = new StatisticsPresenter(new StatisticsViewModel())
) {
  return {
    userLanguageStatisticsList: presenter.userLanguageStatisticsList,
    userDailySolutionList: presenter.userDailySolutionList,
    isLoading: presenter.isLoading,
    error: presenter.error,
    addUserStatistics: presenter.addUserStatistic.bind(presenter),
    removeUserStatistics: presenter.removeUserStatistics.bind(presenter),
    removeTargetUsers: presenter.removeTargetUsers.bind(presenter)
  }
}
